import { Logic } from '~common/ui-logic/logic'
import type { AppContextType } from '~/app-context'

export interface ErrorBoxLogicDependencies {
    errorMessage?: string
}

export interface ErrorBoxLogicState {
    message: string | null
}

export class ErrorBoxLogic extends Logic<
    ErrorBoxLogicDependencies & AppContextType,
    ErrorBoxLogicState
> {
    getInitialState = (): ErrorBoxLogicState => ({
        message: null,
    })

    async initialize() {
        this.setState({ message: this.deps.errorMessage ?? null })
    }
}
